type User = {
  accountId: string;
  _id: string;
};

export function isUserArray(value: unknown): value is User[] {
  return (
    Array.isArray(value) &&
    value.length > 0 &&
    value.every(
      (user) =>
        typeof user === 'object' &&
        'accountId' in user &&
        typeof user.accountId === 'string' &&
        '_id' in user &&
        typeof user._id === 'string'
    )
  );
}

export function isValidDate(date: unknown): date is Date {
  return date instanceof Date && !isNaN(date.getTime());
}

export function isConvertibleToDate(obj: unknown): boolean {
  const date = new Date(obj as Date);
  return isValidDate(date);
}
